import { baseUrl, handleResponse, handleError, GetHeaders } from "../../../../apis/common/ApiUtils";

const apiUrl = baseUrl + "Travel/Employee";

export function getEmployeeStatement(employeeId) {
    return fetch(`${apiUrl}/${employeeId}/Statement`, GetHeaders()).then(handleResponse).catch(handleError);
}